import { Shimmer } from "@/components/ai-elements/shimmer";
import { memo } from "react";

export const StepLabel = memo(
  ({ label, isActive }: { label: string; isActive: boolean }) => {
    if (isActive) {
      return <Shimmer className="text-sm font-medium">{`${label}…`}</Shimmer>;
    }

    return <span className="font-medium text-foreground">{label}</span>;
  },
);
StepLabel.displayName = "StepLabel";
